"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextProviders = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_snack_1 = require("@forto-dev/frontend-infra-snack");
const ContextProviders = ({ children }) => {
    return ((0, jsx_runtime_1.jsxs)(frontend_infra_snack_1.SnackContextProvider, { children: [children, (0, jsx_runtime_1.jsx)(frontend_infra_snack_1.Snack, {})] }));
};
exports.ContextProviders = ContextProviders;
//# sourceMappingURL=ContextProviders.js.map